import { inject, Injectable } from '@angular/core';

import { StatePersistenceService } from '@spartacus/core';
import { Observable, ReplaySubject } from 'rxjs';

import { MEASUREMENT_SYSTEM_CONTEXT_ID } from '../constants/measurement-system-context-id.constant';
import { DpMeasurementSystemService } from '../facade/measurement-system.service';

@Injectable({ providedIn: 'root' })
export class DpMeasurementSystemStatePersistenceService {
  readonly #statePersistenceService = inject(StatePersistenceService);
  readonly #measurementSystemService = inject(DpMeasurementSystemService);

  readonly #initialized$ = new ReplaySubject<unknown>(1);

  initSync(): Observable<unknown> {
    this.#statePersistenceService.syncWithStorage({
      key: MEASUREMENT_SYSTEM_CONTEXT_ID,
      state$: this.#measurementSystemService.getActive(),
      onRead: (state) => this.onRead(state)
    });
    return this.#initialized$;
  }

  protected onRead(valueFromStorage: string | undefined): void {
    if (!this.#measurementSystemService.isInitialized() && valueFromStorage) {
      this.#measurementSystemService.setActive(valueFromStorage);
    }
    if (!this.#initialized$.closed) {
      this.#initialized$.next(undefined);
      this.#initialized$.complete();
    }
  }
}
